import  { useCallback, useEffect, useState } from 'react';
import "./Dashboard.scss";
import TopHeader from '../../components/TopHeader/TopHeader';
import Sidebar from '../../components/Sidebar/Sidebar';
import { Outlet } from 'react-router-dom';
import { useAppSelector } from '../../Store/store';
import Loader from '../../components/Loader/Loader/Loader';

export interface DashboardContextType {
  isHistoryOpen: boolean;
  toggleHistory: () => void;
}

const Dashboard = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(true);
  const [isHistoryOpen, setIsHistoryOpen] = useState(true);
  const loading = useAppSelector((state) => state.auth.loading);

  const toggleMenu = useCallback(() => {
    setIsMenuOpen(prevState => !prevState);
  }, []);

  const toggleHistory = useCallback(() => {
    setIsHistoryOpen(prevState => !prevState);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 991) {
        setIsMenuOpen(false); // Close the sidebar on small screens
        setIsHistoryOpen(false); // Close the chat history on small screens
      } else {
        setIsMenuOpen(true); // Open the sidebar on large screens
        setIsHistoryOpen(true); // Open the chat history on large screens
      }
    };
    handleResize();

    // Add resize event listener
    window.addEventListener('resize', handleResize);

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  if(loading){
      return <Loader />;
    }
  return (
    <div className="dashboard-wrapper">
      <TopHeader onMenuToggle={toggleMenu} onHistoryToggle={toggleHistory} />
      <div className="dashboard-main-content-wrap">
        <Sidebar isMenuOpen={isMenuOpen} onMenuToggle={toggleMenu} />
        
        {/* This Outlet will render nested route components */}
        <Outlet context={{isHistoryOpen , toggleHistory}}/>
      </div>
    </div>
  );
};

export default Dashboard;
export type  {Dashboard} ;